import React from "react";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import ErrorCard from "../../components/molecules/errorCard/errorCard";
import {useTranslation} from "react-i18next";
import {RoutePaths} from "../../shared/routePaths";

const PageNotFound: React.FC = () => {
  const {t} = useTranslation(["translation"]);
  return (
    <ErrorCard
      title="404"
      error={t("translation:pageNotFound")}
      resolution={t("translation:pageNotFoundResolution")}
    >
      <Button color="primary" to={RoutePaths.Home} tag={Link}>
        {t("translation:returnHome")}
      </Button>
    </ErrorCard>
  );
};

export default PageNotFound;
